import { Grid, Typography, Box, IconButton, Button } from "@mui/material";
import React from "react";
import { ArticuloKiosk } from "../articulos/articulo-kiosk";
import { useTheme } from "@emotion/react";

export const Detalles = ({
  productos,
  factura,
  handleDelete,
  handleIncrease,
  handleDecrease,
  isYPF,
  handleClickImg,
}) => {
  const theme = useTheme();
  return (
    <>
      <Grid item sx={{ flex: 0.5 }}></Grid>
      <Grid item sx={{ flex: 4, ml: 5, p: 2 }}>
        <ArticuloKiosk
          productos={productos}
          handleDelete={handleDelete}
          handleIncrease={handleIncrease}
          handleDecrease={handleDecrease}
          handleClickImg={handleClickImg}
        />
      </Grid>
      <Grid item sx={{ flex: 0.5 }}>
        <Box
          sx={{
            p: 2,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            ...(isYPF && { mt: 7 }),
          }}
        >
          {!isYPF && (
            <>
              <Button
                variant="contained"
                sx={{
                  background: "#fff",
                  "&:hover": { background: theme.bandera.colorSecundario },
                  color: "#000",
                  fontSize: 20,
                  width: 200,
                  borderRadius: 5,
                }}
                onClick={() => factura(false)}
              >
                Factura A Contado
              </Button>
              <Button
                variant="contained"
                sx={{
                  background: "#fff",
                  "&:hover": { background: theme.bandera.colorSecundario },
                  color: "#000",
                  fontSize: 20,
                  width: 200,
                  borderRadius: 5,
                  ml: 5,
                }}
                onClick={() => factura(true)}
              >
                Consumidor Final
              </Button>
            </>
          )}
        </Box>
      </Grid>
    </>
  );
};
